"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenForSessionCreation = exports.isOpenForRegistration = void 0;
const models_1 = require("../models");
const isOpenForRegistration = (competitionRound) => {
    var _a;
    if (!competitionRound) {
        return false;
    }
    return ([models_1.CompetitionRoundState.OPEN, models_1.CompetitionRoundState.RUNNING].includes(competitionRound.state) && ((_a = competitionRound.competition) === null || _a === void 0 ? void 0 : _a.allowRegistration));
};
exports.isOpenForRegistration = isOpenForRegistration;
const isOpenForSessionCreation = (competitionRound, end) => {
    if ((competitionRound === null || competitionRound === void 0 ? void 0 : competitionRound.end) && end >= competitionRound.end) {
        return false;
    }
    return [models_1.CompetitionRoundState.RUNNING].includes(competitionRound.state);
};
exports.isOpenForSessionCreation = isOpenForSessionCreation;
//# sourceMappingURL=competition-utils.js.map